import { render, staticRenderFns } from "./SmsBroadcastMaxRecipientsAlert.vue?vue&type=template&id=5b3088a8&scoped=true"
import script from "./SmsBroadcastMaxRecipientsAlert.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastMaxRecipientsAlert.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastMaxRecipientsAlert.vue?vue&type=style&index=0&id=5b3088a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3088a8",
  null
  
)

export default component.exports